import React from 'react';
import { Avatar } from '../../shared/Avatar';
import { MasteryBar } from '../../shared/MasteryBar';
import type { SchoolData } from './types';
interface SchoolDetailPanelProps {
  school: SchoolData;
}
export function SchoolDetailPanel({
  school
}: SchoolDetailPanelProps) {
  return <div className="space-y-6" data-id="element-4573">
      <div className="grid grid-cols-3 gap-3" data-id="element-4574">
        <div className="bg-purple-50 rounded-lg p-3 text-center" data-id="element-4575">
          <div className="text-2xl font-bold text-purple-700" data-id="element-4576">
            {school.learnerCount}
          </div>
          <div className="text-xs text-purple-600" data-id="element-4577">Leerlingen</div>
        </div>
        <div className="bg-indigo-50 rounded-lg p-3 text-center" data-id="element-4578">
          <div className="text-2xl font-bold text-indigo-700" data-id="element-4579">
            {school.teacherCount}
          </div>
          <div className="text-xs text-indigo-600" data-id="element-4580">Docenten</div>
        </div>
        <div className="bg-emerald-50 rounded-lg p-3 text-center" data-id="element-4581">
          <div className="text-2xl font-bold text-emerald-700" data-id="element-4582">
            {school.avgMastery}%
          </div>
          <div className="text-xs text-emerald-600" data-id="element-4583">Gem. beheersing</div>
        </div>
      </div>

      {school.teachers.length > 0 && <div data-id="element-4584">
          <h3 className="text-sm font-semibold text-gray-900 mb-3" data-id="element-4585">Docenten</h3>
          <div className="space-y-1" data-id="element-4586">
            {school.teachers.map(t => <div key={t.id} className="flex items-center gap-2 py-1.5" data-id="element-4587">
                <Avatar name={t.name} data-id="element-4588" />
                <span className="text-sm text-gray-700" data-id="element-4589">{t.name}</span>
              </div>)}
          </div>
        </div>}

      {school.learners.length > 0 && <div data-id="element-4590">
          <h3 className="text-sm font-semibold text-gray-900 mb-3" data-id="element-4591">
            Leerlingen
          </h3>
          <div className="space-y-2" data-id="element-4592">
            {school.learners.map(learner => <div key={learner.id} className="flex items-center justify-between py-2 border-b border-gray-50 last:border-0" data-id="element-4593">
                <div className="flex items-center gap-2" data-id="element-4594">
                  <Avatar name={learner.name} data-id="element-4595" />
                  <div data-id="element-4596">
                    <div className="text-sm text-gray-800" data-id="element-4597">{learner.name}</div>
                    <div className="text-xs text-gray-400" data-id="element-4598">
                      {learner.account && 'grade' in learner.account ? `Groep ${learner.account.grade}` : '—'}{' '}
                      · {learner.sessionCount} sessies
                    </div>
                  </div>
                </div>
                <MasteryBar value={learner.avgMastery || 0} data-id="element-4599" />
              </div>)}
          </div>
        </div>}
    </div>;
}